export default __webpack_public_path__ + "static/media/diploma-bazi-mas-feng-shui_2024.2f9be826.jpeg";